export const STORAGE_COOKIE_CONSENT = "onmo_consent";

export interface ICookieConsent {
  functional: boolean;
  analytics: boolean;
}

export const ACCEPT_ALL: ICookieConsent = { functional: true, analytics: true };
export const REJECT_ALL: ICookieConsent = {
  functional: false,
  analytics: false,
};

export const getCookieConsent = (): ICookieConsent | null => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_COOKIE_CONSENT) || "null");
  } catch {
    return null;
  }
};

export const saveCookieConsent = (consent: ICookieConsent) => {
  localStorage.setItem(
    STORAGE_COOKIE_CONSENT,
    JSON.stringify({
      functional: consent.functional,
      analytics: consent.analytics,
    }),
  );
  window.dispatchEvent(new Event(STORAGE_COOKIE_CONSENT));
};

export const isFunctionalAllowed = () =>
  getCookieConsent()?.functional === true;

export const isAnalyticsAllowed = () => getCookieConsent()?.analytics === true;
